import { render, staticRenderFns } from "./Stage3.vue?vue&type=template&id=07e2f8d2&scoped=true"
import script from "./Stage3.vue?vue&type=script&lang=js"
export * from "./Stage3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e2f8d2",
  null
  
)

export default component.exports